import { UNSUBSCRIBED_EMAIL, UNSUBSCRIBED_EMAIL_FAILED, UNSUBSCRIBED_EMAIL_SUCCESS, SUBSCRIBED_EMAIL} from "./actionTypes"

// Unsubscribed Email
export const getUnsubscribed = data => ({
    type: UNSUBSCRIBED_EMAIL,
    payload: data,
})

export const getUnsubscribedSuccess = data => (
    {
        type: UNSUBSCRIBED_EMAIL_SUCCESS,
        payload: data,
    })

export const getUnsubscribedFailed = data => ({
    type: UNSUBSCRIBED_EMAIL_FAILED,
    payload: data,
})

// subscribed Email
export const getSubscribed = data => ({
    type: SUBSCRIBED_EMAIL,
    payload: data,
})
